// extracted by mini-css-extract-plugin
export var resizer = "_hx-0";